if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.submitButton = this.querySelector('[data-sticky-submit]');
        this.submitButtonText = this.querySelector('[data-sticky-submit-text]');
      }

      connectedCallback() {
        const anchor = document.getElementById(this.dataset.anchorId);

        if (anchor && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              const scrolledPast = entry && !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.toggleAttribute('data-visible', Boolean(scrolledPast));
            },
            { threshold: 0 }
          );
          this.observer.observe(anchor);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event?.data || event.data.sectionId !== this.sectionId) return;
            this.updateFromHtml(event.data.html);
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
      }

      updateFromHtml(html) {
        if (!html) return;

        const sourcePrice = html.getElementById(`price-${this.sectionId}`);
        if (sourcePrice && this.priceTarget) {
          this.priceTarget.innerHTML = sourcePrice.innerHTML;
        }

        const sourceButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (sourceButton && this.submitButton) {
          const disabled = sourceButton.hasAttribute('disabled');
          this.submitButton.toggleAttribute('disabled', disabled);
          if (this.submitButtonText) {
            this.submitButtonText.textContent = sourceButton.querySelector('span')?.textContent?.trim() || '';
          }
        }
      }
    }
  );
}
